var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 2.66675C8.64008 2.66675 2.66675 8.64008 2.66675 16.0001C2.66675 23.3601 8.64008 29.3334 16.0001 29.3334C23.3601 29.3334 29.3334 23.3601 29.3334 16.0001C29.3334 8.64008 23.3601 2.66675 16.0001 2.66675ZM19.5467 18.3067L17.8401 19.2934L16.1334 20.2801C13.9334 21.5467 12.1334 20.5067 12.1334 17.9734V16.0001V14.0267C12.1334 11.4801 13.9334 10.4534 16.1334 11.7201L17.8401 12.7067L19.5467 13.6934C21.7467 14.9601 21.7467 17.0401 19.5467 18.3067Z",
    fill: "#50A5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFileIcon);
export default __webpack_public_path__ + "static/media/VideoFileIcon.3a7c8d7a988d3d315b666534fccd18a1.svg";
export { ForwardRef as ReactComponent };